export class Const {
}
Const.ENUM_TEXTALIGN_DEFAULT = 0;
Const.ENUM_TEXTALIGN_CENTER = 1;
Const.ENUM_TEXTALIGN_RIGHT = 2;
Const.INDEX_BYTES = 2;
Const.MAX_CLIP_SIZE = 99999999;
export class NodeFlags {
}
NodeFlags.ACTIVE = 0x1;
NodeFlags.ACTIVE_INHIERARCHY = 0x2;
NodeFlags.AWAKED = 0x4;
NodeFlags.ACTUAL_VISIBLE = 0x8;
NodeFlags.DISPLAY = 0x10;
NodeFlags.HAS_ZORDER = 0x20;
NodeFlags.AREA_2D = 0x40;
NodeFlags.DISPLAYED_INSTAGE = 0x80;
NodeFlags.DRAWCALL_OPTIMIZE = 0x100;
NodeFlags.CHECK_INPUT = 0x200;
NodeFlags.DEMAND_TRANS_EVENT = 0x400;
NodeFlags.HAS_SCRIPT = 0x800;
NodeFlags.ESCAPE_DRAWING_TO_TEXTURE = 0x1000;
NodeFlags.DISABLE_INNER_CLIPPING = 0x2000;
NodeFlags.DISABLE_OUTER_CLIPPING = 0x4000;
NodeFlags.FORCE_VISIBLE = 0x8000;
NodeFlags.EDITING_NODE = 0x10000;
NodeFlags.HIDE_BY_EDITOR = 0x20000;
NodeFlags.LOCK_BY_EDITOR = 0x40000;
NodeFlags.EDITING_ROOT_NODE = 0x80000;
NodeFlags.FORCE_HIDDEN = 0x100000;
NodeFlags.NOT_IN_PAGE = 0x200000;
NodeFlags.ESCAPE_LAYOUT = 0x400000;
export class HideFlags {
}
HideFlags.HideInHierarchy = 0x1;
HideFlags.HideInInspector = 0x2;
HideFlags.DontSave = 0x4;
HideFlags.HideAndDontSave = 0x7;
